import {
  SnackbarProvider as NotiSnackbarProvider,
  SnackbarProviderProps,
} from "notistack";
import React from "react";
import { SnackbarComponent } from "../components";
import { ISnackbarComponentProps } from "../components/SnackbarComponent";

export type ISnackbarContextProviderProps = Pick<
  SnackbarProviderProps,
  "autoHideDuration" | "anchorOrigin" | "children"
>;

export const SnackbarProvider = ({
  children,
}: {
  children: React.ReactNode;
}) => {
  return (
    <NotiSnackbarProvider
      // default props, can be overwritten in calling function
      autoHideDuration={5000}
      anchorOrigin={{ vertical: "bottom", horizontal: "right" }}
      variant="error"
      Components={{
        success: SnackbarComponent,
        error: SnackbarComponent,
        warning: SnackbarComponent,
        default: SnackbarComponent,
      }}
      maxSnack={5}
    >
      {children}
    </NotiSnackbarProvider>
  );
};

declare module "notistack" {
  // fix error
  type ISnackbarProps = Omit<ISnackbarComponentProps, "">;
  interface VariantOverrides {
    success: ISnackbarProps;
    error: ISnackbarProps;
    warning: ISnackbarProps;
    default: ISnackbarProps;
  }
}
